<script>
import IconFuel from "../Svg/IconFuel.vue";
import icon from "../../mixins/icon";

export default {
    name: "RadioCard",
    components: {IconFuel},

    props: {
        option: {
            Type: Object,
            required: true
        },
        selectedOptionId: {
            Type: String,
            required: false,
            default: ''
        }
    },

    mixins: [icon],

    computed: {
        checked() {
            return this.selectedOptionId === this.option.id;
        }
    }
}
</script>

<template>
    <div class="vue-radio-card" :class="{'checked': checked}" @click.stop="$emit('input', option.id)">
        <component :is="getIcon(option.id)" />
        <input type="radio" :id="option.id" :value="option.id" :checked="checked" class="visually-hidden" @input="$emit('input', option.id)">
        <label :for="option.id">{{ option.label }}</label>
    </div>
</template>
